import { useI18n } from "@/i18n/I18nProvider";
import Reveal, { stagger, fadeUp } from "@/components/motion/Reveal";

export default function Leadership() {
  const { t } = useI18n();
  const l = t.leadership;
  return (
    <section id="leadership" data-testid="leadership-section" className="section-pad bg-surface-muted relative">
      <div className="absolute inset-0 noise-overlay pointer-events-none" aria-hidden />
      <div className="container-pro relative">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <Reveal className="md:col-span-5">
            <div className="overline">{l.kicker}</div>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight">{l.title}</h2>
          </Reveal>
          <Reveal variants={fadeUp} className="md:col-span-7 md:pt-2">
            <p className="text-ink-secondary md:text-lg">{l.body}</p>
          </Reveal>
        </div>

        <Reveal variants={stagger(0.06, 0.12)} className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {l.team.map((m) => (
            <Reveal
              key={m.name}
              variants={fadeUp}
              data-testid="team-card"
              className="group relative bg-white border border-line rounded-xl p-8 glow-card"
            >
              <div data-testid="team-avatar" className="relative h-20 w-20 rounded-xl bg-brand-black flex items-center justify-center overflow-hidden transition-transform duration-300 group-hover:scale-105">
                <span className="font-heading text-2xl font-semibold text-white tracking-tight">{m.initials}</span>
                <span className="absolute -top-1 -end-1 h-3 w-3 rounded-sm bg-brand-red" aria-hidden />
              </div>
              <h3 className="mt-6 font-heading text-xl font-semibold">{m.name}</h3>
              <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-red mt-1">{m.role}</div>
              <p className="mt-4 text-sm text-ink-secondary leading-relaxed">{m.note}</p>
            </Reveal>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
